import * as React from 'react';
import { Menu } from '@dropbox/dig-components/menu';
/**
 * The empty state.
 * This component is not exported.
 */
export const Empty = ({ emptyMessage }) => {
    return React.createElement(Menu.Row, { interactive: false, withTitle: emptyMessage });
};
Empty.displayName = 'NotificationEmpty';
